import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SiteFooter from './SiteFooter';
import { legalConfig } from '../config/legal';
import './LegalPage.css';

const LegalPage = ({ title, children }) => {
  const { t } = useTranslation('public');

  return (
    <div className="legal-page">
      <header className="legal-page__header">
        <Link to="/" className="legal-page__home-link">
          &larr; {t('legalBackHome')}
        </Link>
        <h1>{title}</h1>
        <p className="legal-page__meta">
          {t('legalLastUpdated', {
            date: legalConfig.lastUpdated,
            entityName: legalConfig.entityName
          })}
        </p>
      </header>
      <main className="legal-page__content">
        {children}
      </main>
      <SiteFooter />
    </div>
  );
};

export default LegalPage;
